/* eslint-disable max-lines */
/*
  These are only used for translation purposes. Subjects are defined at
  ../definitions/subjects.js.
*/
const SUBJECTS = [
  {
    id: 'äidinkieli',
    'fi-FI': 'Äidinkieli',
    'sv-FI': 'Modersmål',
  },
  {
    id: 'äidinkieli-suomi-lukutaidon-koe',
    'fi-FI': 'Äidinkieli, suomi, lukutaidon koe',
    'sv-FI': 'Modersmål, finska, läskompetensprovet',
  },
  {
    id: 'äidinkieli-ruotsi-essee',
    'fi-FI': 'Äidinkieli, ruotsi, esseekoe',
    'sv-FI': 'Modersmål, svenska, essäprov',
  },
  {
    id: 'äidinkieli-ruotsi-tekstitaito',
    'fi-FI': 'Äidinkieli, ruotsi, tekstitaidon koe',
    'sv-FI': 'Modersmål, svenska, textkompetens',
  },
  {
    id: 'äidinkieli-ruotsi-lukutaidon-koe',
    'fi-FI': 'Äidinkieli, ruotsi, lukutaidon koe',
    'sv-FI': 'Modersmål, svenska, läskompetensprovet',
  },
  {
    id: 'äidinkieli-suomi-essee',
    'fi-FI': 'Äidinkieli, suomi, kirjoitustaito',
    'sv-FI': 'Modersmål, finska, essäprov',
  },
  {
    id: 'äidinkieli-suomi-tekstitaito',
    'fi-FI': 'Äidinkieli, suomi, tekstitaidon koe',
    'sv-FI': 'Modersmål, finska, textkompetens',
  },
  {
    id: 'biologia',
    'fi-FI': 'Biologia',
    'sv-FI': 'Biologi',
  },
  {
    id: 'elämänkatsomustieto',
    'fi-FI': 'Elämänkatsomustieto',
    'sv-FI': 'Livsåskådningskunskap',
  },
  {
    id: 'englanti',
    'fi-FI': 'Englanti',
    'sv-FI': 'Engelska',
  },
  {
    id: 'englanti-lyhyt',
    'fi-FI': 'Englanti, lyhyt oppimäärä',
    'sv-FI': 'Engelska, kort lärokurs',
  },
  {
    id: 'englanti-pitkä',
    'fi-FI': 'Englanti, pitkä oppimäärä',
    'sv-FI': 'Engelska, lång lärokurs',
  },
  {
    id: 'espanja',
    'fi-FI': 'Espanja',
    'sv-FI': 'Spanska',
  },
  {
    id: 'espanja-lyhyt',
    'fi-FI': 'Espanja, lyhyt oppimäärä',
    'sv-FI': 'Spanska, kort lärokurs',
  },
  {
    id: 'espanja-pitkä',
    'fi-FI': 'Espanja, pitkä oppimäärä',
    'sv-FI': 'Spanska, lång lärokurs',
  },
  {
    id: 'uskonto-evlut',
    'fi-FI': 'Evankelisluterilainen uskonto',
    'sv-FI': 'Evangelisk-luthersk religion',
  },
  {
    id: 'filosofia',
    'fi-FI': 'Filosofia',
    'sv-FI': 'Filosofi',
  },
  {
    id: 'fysiikka',
    'fi-FI': 'Fysiikka',
    'sv-FI': 'Fysik',
  },
  {
    id: 'historia',
    'fi-FI': 'Historia',
    'sv-FI': 'Historia',
  },
  {
    id: 'saame-inari',
    'fi-FI': 'Inarinsaame',
    'sv-FI': 'Enaresamiska',
  },
  {
    id: 'saame-inari-aidinkieli-ja-kirjallisuus',
    'fi-FI': 'Inarinsaame, äidinkieli ja kirjallisuus',
    'sv-FI': 'Enaresamiska, modersmål och skönlitteratur',
  },
  {
    id: 'saame-inari-lyhyt',
    'fi-FI': 'Inarinsaame, lyhyt oppimäärä',
    'sv-FI': 'Enaresamiska, kort lärokurs',
  },
  {
    id: 'italia',
    'fi-FI': 'Italia',
    'sv-FI': 'Italienska',
  },
  {
    id: 'italia-lyhyt',
    'fi-FI': 'Italia, lyhyt oppimäärä',
    'sv-FI': 'Italienska, kort lärokurs',
  },
  {
    id: 'käsityö',
    'fi-FI': 'Käsityö',
    'sv-FI': 'Handarbete',
  },
  {
    id: 'kemia',
    'fi-FI': 'Kemia',
    'sv-FI': 'Kemi',
  },
  {
    id: 'saame-kolta',
    'fi-FI': 'Koltansaame',
    'sv-FI': 'Skoltsamiska',
  },
  {
    id: 'saame-kolta-lyhyt',
    'fi-FI': 'Koltansaame, lyhyt oppimäärä',
    'sv-FI': 'Skoltsamiska, kort lärokurs',
  },
  {
    id: 'kotitalous',
    'fi-FI': 'Kotitalous',
    'sv-FI': 'Hushållslära',
  },
  {
    id: 'kuvatiede',
    'fi-FI': 'Kuvatiede',
    'sv-FI': 'Bildkonst',
  },
  {
    id: 'latina',
    'fi-FI': 'Latina',
    'sv-FI': 'Latin',
  },
  {
    id: 'latina-lyhyt',
    'fi-FI': 'Latina, lyhyt oppimäärä',
    'sv-FI': 'Latin, kort lärokurs',
  },
  {
    id: 'latina-pidempi',
    'fi-FI': 'Latina, pidempi oppimäärä',
    'sv-FI': 'Latin, längre lärokurs',
  },
  {
    id: 'maantiede',
    'fi-FI': 'Maantiede',
    'sv-FI': 'Geografi',
  },
  {
    id: 'matematiikka',
    'fi-FI': 'Matematiikka',
    'sv-FI': 'Matematik',
  },
  {
    id: 'matematiikka-lyhyt',
    'fi-FI': 'Matematiikka, lyhyt oppimäärä',
    'sv-FI': 'Matematik, kort lärokurs',
  },
  {
    id: 'matematiikka-pitkä',
    'fi-FI': 'Matematiikka, pitkä oppimäärä',
    'sv-FI': 'Matematik, lång lärokurs',
  },
  {
    id: 'musiikki',
    'fi-FI': 'Musiikki',
    'sv-FI': 'Musik',
  },
  {
    id: 'muu',
    'fi-FI': 'Muu',
    'sv-FI': 'Övrigt',
  },
  {
    id: 'uskonto-ortodoksinen',
    'fi-FI': 'Ortodoksinen uskonto',
    'sv-FI': 'Ortodox religion',
  },
  {
    id: 'saame-pohjois',
    'fi-FI': 'Pohjoissaame',
    'sv-FI': 'Nordsamiska',
  },
  {
    id: 'saame-pohjois-aidinkieli-ja-kirjallisuus',
    'fi-FI': 'Pohjoissaame, äidinkieli ja kirjallisuus',
    'sv-FI': 'Nordsamiska, modersmål och skönlitteratur',
  },
  {
    id: 'saame-pohjois-lyhyt',
    'fi-FI': 'Pohjoissaame, lyhyt oppimäärä',
    'sv-FI': 'Nordsamiska, kort lärokurs',
  },
  {
    id: 'portugali',
    'fi-FI': 'Portugali',
    'sv-FI': 'Portugisiska',
  },
  {
    id: 'portugali-lyhyt',
    'fi-FI': 'Portugali, lyhyt oppimäärä',
    'sv-FI': 'Portugisiska, kort lärokurs',
  },
  {
    id: 'psykologia',
    'fi-FI': 'Psykologia',
    'sv-FI': 'Psykologi',
  },
  {
    id: 'ranska',
    'fi-FI': 'Ranska',
    'sv-FI': 'Franska',
  },
  {
    id: 'ranska-lyhyt',
    'fi-FI': 'Ranska, lyhyt oppimäärä',
    'sv-FI': 'Franska, kort lärokurs',
  },
  {
    id: 'ranska-pitkä',
    'fi-FI': 'Ranska, pitkä oppimäärä',
    'sv-FI': 'Franska, lång lärokurs',
  },
  {
    id: 'ruotsi',
    'fi-FI': 'Ruotsi',
    'sv-FI': 'Svenska',
  },
  {
    id: 'ruotsi-toisena',
    'fi-FI': 'Ruotsi toisena kielenä',
    'sv-FI': 'Svenska som andra språk',
  },
  {
    id: 'ruotsi-keskipitkä',
    'fi-FI': 'Ruotsi, keskipitkä oppimäärä',
    'sv-FI': 'Svenska, medellång lärokurs',
  },
  {
    id: 'ruotsi-pitkä',
    'fi-FI': 'Ruotsi, pitkä oppimäärä',
    'sv-FI': 'Svenska, lång lärokurs',
  },
  {
    id: 'saksa',
    'fi-FI': 'Saksa',
    'sv-FI': 'Tyska',
  },
  {
    id: 'saksa-lyhyt',
    'fi-FI': 'Saksa, lyhyt oppimäärä',
    'sv-FI': 'Tyska, kort lärokurs',
  },
  {
    id: 'saksa-pitkä',
    'fi-FI': 'Saksa, pitkä oppimäärä',
    'sv-FI': 'Tyska, lång lärokurs',
  },
  {
    id: 'suomi-toisena',
    'fi-FI': 'Suomi toisena kielenä',
    'sv-FI': 'Finska som andra språk',
  },
  {
    id: 'suomi-keskipitkä',
    'fi-FI': 'Suomi, keskipitkä oppimäärä',
    'sv-FI': 'Finska, medellång lärokurs',
  },
  {
    id: 'suomi-pitkä',
    'fi-FI': 'Suomi, pitkä oppimäärä',
    'sv-FI': 'Finska, lång lärokurs',
  },
  {
    id: 'terveystieto',
    'fi-FI': 'Terveystieto',
    'sv-FI': 'Hälsokunskap',
  },
  {
    id: 'venäjä',
    'fi-FI': 'Venäjä',
    'sv-FI': 'Ryska',
  },
  {
    id: 'venäjä-lyhyt',
    'fi-FI': 'Venäjä, lyhyt oppimäärä',
    'sv-FI': 'Ryska, kort lärokurs',
  },
  {
    id: 'venäjä-pitkä',
    'fi-FI': 'Venäjä, pitkä oppimäärä',
    'sv-FI': 'Ryska, lång lärokurs',
  },
  {
    id: 'yhteiskuntaoppi',
    'fi-FI': 'Yhteiskuntaoppi',
    'sv-FI': 'Samhällslära',
  },
  {
    id: 'näkövammaiset-englanti-lyhyt',
    'fi-FI': 'Englanti, lyhyt oppimäärä, näkövammaiset',
    'sv-FI': 'Engelska, kort lärokurs, synskadade',
  },
  {
    id: 'näkövammaiset-ranska-lyhyt',
    'fi-FI': 'Ranska, lyhyt oppimäärä, näkövammaiset',
    'sv-FI': 'Franska, kort lärokurs, synskadade',
  },
  {
    id: 'näkövammaiset-matematiikka-lyhyt',
    'fi-FI': 'Matematiikka, lyhyt oppimäärä, näkövammaiset',
    'sv-FI': 'Matematik, kort lärokurs, synskadade',
  },
  {
    id: 'näkövammaiset-matematiikka-pitkä',
    'fi-FI': 'Matematiikka, pitkä oppimäärä, näkövammaiset',
    'sv-FI': 'Matematik, lång lärokurs, synskadade',
  },
  {
    id: 'näkövammaiset-biologia',
    'fi-FI': 'Biologia, näkövammaiset',
    'sv-FI': 'Biologi, synskadade',
  },
  {
    id: 'näkövammaiset-filosofia',
    'fi-FI': 'Filosofia, näkövammaiset',
    'sv-FI': 'Filosofi, synskadade',
  },
  {
    id: 'näkövammaiset-fysiikka',
    'fi-FI': 'Fysiikka, näkövammaiset',
    'sv-FI': 'Fysik, synskadade',
  },
  {
    id: 'näkövammaiset-yhteiskuntaoppi',
    'fi-FI': 'Yhteiskuntaoppi, näkövammaiset',
    'sv-FI': 'Samhällslära, synskadade',
  },
  {
    id: 'näkövammaiset-ruotsi-keskipitkä',
    'fi-FI': 'Ruotsi, keskipitkä oppimäärä, näkövammaiset',
    'sv-FI': 'Svenska, medellång lärokurs, synskadade',
  },
  {
    id: 'näkövammaiset-ruotsi-pitkä',
    'fi-FI': 'Ruotsi, pitkä oppimäärä, näkövammaiset',
    'sv-FI': 'Svenska, lång lärokurs, synskadade',
  },
  {
    id: 'näkövammaiset-terveystieto',
    'fi-FI': 'Terveystieto, näkövammaiset',
    'sv-FI': 'Hälsokunskap, synskadade',
  },
  {
    id: 'näkövammaiset-psykologia',
    'fi-FI': 'Psykologia, näkövammaiset',
    'sv-FI': 'Psykologi, synskadade',
  },
  {
    id: 'näkövammaiset-englanti-pitkä',
    'fi-FI': 'Englanti, pitkä oppimäärä, näkövammaiset',
    'sv-FI': 'Engelska, lång lärokurs, synskadade',
  },
  {
    id: 'näkövammaiset-äidinkieli-kirjoitustaidon-koe',
    'fi-FI': 'Äidinkieli, kirjoitustaidon koe, näkövammaiset',
    'sv-FI': 'Modersmål, essäprov, synskadade',
  },
  {
    id: 'näkövammaiset-äidinkieli-lukutaidon-koe',
    'fi-FI': 'Äidinkieli, lukutaidon koe, näkövammaiset',
    'sv-FI': 'Modersmål, läskompetensprovet, synskadade',
  },
  {
    id: 'näkövammaiset-maantiede',
    'fi-FI': 'Maantiede, näkövammaiset',
    'sv-FI': 'Geografi, synskadade',
  },
  {
    id: 'näkövammaiset-historia',
    'fi-FI': 'Historia, näkövammaiset',
    'sv-FI': 'Historia, synskadade',
  },
  {
    id: 'näkövammaiset-suomi-toisena-kielenä',
    'fi-FI': 'Suomi toisena kielenä, näkövammaiset',
    'sv-FI': 'Finska som andra språk, synskadade',
  },
  {
    id: 'näkövammaiset-evankelisluterilainen-uskonto',
    'fi-FI': 'Evankelisluterilainen uskonto, näkövammaiset',
    'sv-FI': 'Evangelisk-luthersk religion, synskadade',
  },
  {
    id: 'kuulovammaiset-espanja-lyhyt',
    'fi-FI': 'Kuulovammaisten koe, espanja, lyhyt oppimäärä',
    'sv-FI': 'Provet för hörselskadade, spanska, kort lärokurs',
  },
  {
    id: 'kuulovammaiset-englanti-pitkä',
    'fi-FI': 'Kuulovammaisten koe, englanti, pitkä oppimäärä',
    'sv-FI': 'Provet för hörselskadade, engelska, lång lärokurs',
  },
  {
    id: 'kuulovammaiset-englanti-lyhyt',
    'fi-FI': 'Kuulovammaisten koe, englanti, lyhyt oppimäärä',
    'sv-FI': 'Provet för hörselskadade, engelska, kort lärokurs',
  },
  {
    id: 'kuulovammaiset-toinen-kotimainen-pitkä',
    'fi-FI': 'Kuulovammaisten koe, toinen kotimainen kieli, pitkä oppimäärä',
    'sv-FI': 'Provet för hörselskadade, det andra inhemska språket, lång lärokurs',
  },
  {
    id: 'kuulovammaiset-toinen-kotimainen-keskipitkä',
    'fi-FI': 'Kuulovammaisten koe, toinen kotimainen kieli, keskipitkä oppimäärä',
    'sv-FI': 'Provet för hörselskadade, det andra inhemska språket, medellång lärokurs',
  },
  {
    id: 'kuulovammaiset-saksa-lyhyt',
    'fi-FI': 'Kuulovammaisten koe, saksa, lyhyt oppimäärä',
    'sv-FI': 'Provet för hörselskadade, tyska, kort lärokurs',
  },
  {
    id: 'kuulovammaiset-suomi-toisena-ja-kirjallisuus',
    'fi-FI': 'Kuulovammaisten koe, suomi toisena kielenä ja kirjallisuus',
    'sv-FI': 'Provet för hörselskadade, finska som andraspråk och litteratur',
  },
]

export default SUBJECTS
